var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.navbar.active)?_c('header',{staticClass:"site-header nf-sticky-top"},[_c('nf-menu',{staticClass:"navbar-default",attrs:{"id":"navbar","name":"navbar","title":_vm.navbar.title,"logo":_vm.navbar.logo,"has-favorites":false,"has-search":false},on:{"click-logo":_vm.redirectToHome}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }